

export class Conservacion {
    idconservacion: string;
    iditem: string;
    estado: string;
    alteraciones: string;
}
